import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2023dd2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { ref, reactive, computed, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { MenuItem } from "@/types/userCenter";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'SubMenusUserCenter',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const helpMenus = reactive<MenuItem[]>([
  {
    id: 1,
    path: "/userCenter/personal",
    lang: "user_center.personal_info",
  },
  {
    id: 2,
    path: "/userCenter/account",
    lang: "user_center.order_info",
  },
]);
const store = useStore();
const isMobile = computed(() => !!store.state.isMobile);

const activeMenuPath = ref("");
const initActiveMenuName = () => {
  const menuItem = helpMenus.find((i) => route.path === i.path);
  console.log("init", menuItem);
  activeMenuPath.value = menuItem ? menuItem.path : "";
};
watch(
  () => router.currentRoute.value,
  () => {
    activeMenuPath.value = router.currentRoute.value.path;
  }
);
initActiveMenuName();
const changeRouter = (item: MenuItem): void => {
  store.dispatch("getUserInfo");
  router.push(item.path).then((res) => {
    initActiveMenuName();
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", {
    class: _normalizeClass({ mobileSize: _unref(isMobile) })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(helpMenus, (item, index) => {
      return (_openBlock(), _createElementBlock("li", {
        onClick: ($event: any) => (changeRouter(item)),
        class: _normalizeClass({ active: item.path.startsWith(activeMenuPath.value) }),
        key: index
      }, _toDisplayString(_ctx.$t(item.lang)), 11, _hoisted_1))
    }), 128))
  ], 2))
}
}

})